import { render, staticRenderFns } from "./AppTitle.vue?vue&type=template&id=565c2370&"
import script from "./AppTitle.js?vue&type=script&lang=js&"
export * from "./AppTitle.js?vue&type=script&lang=js&"
import style0 from "./AppTitle.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports